// extracted by mini-css-extract-plugin
module.exports = {"controller":"search-control_controller__AJChY"};